import axios from "axios";
import {AppDispatch, RootState} from "../app/store";
import {IBarcode} from "../interfaces/Barcode";
import {defaultBarcode} from "../utils/defaultBarcode";
import {IItem} from "../interfaces/Item";
import {CHANGE_BARCODE_NO_HISTORY, CHANGE_BARCODE_VALUE} from "./MainReducer";
import localforage from "localforage";
import { showErrorToast } from "../utils/showToast";
import i18n from "i18next";
export const GenerateBarcode = (itemid: number, barcode: IBarcode = defaultBarcode) => {
  return async (dispatch: AppDispatch, getState: () => RootState) => {
    try {
      const {dpi, showDefaultValues} = getState().labelEdit.present.labelParams;
      const response = await axios.post(`api/Barcode/GenerateBarcode?_dpi=${dpi}&_showDefaultValues=${showDefaultValues}`, barcode, {
        headers: {
          "Content-Type": "application/json",
        },
        responseType: "blob",
      });
      const blob = new Blob([response.data], {type: response.headers["content-type"]});
      await localforage.setItem(itemid.toString(), blob);
      const blobUrl = URL.createObjectURL(blob);
      return blobUrl;
    } catch (error) {
      showErrorToast(i18n.t("error"), i18n.t("barcode_fetch_error"));
      return null;
    }
  };
};

export const ChangeBarcodeValue = (item: IItem, propName: string, propValue: string, value: string) => {
  return async (dispatch: AppDispatch) => {
    if (item.selected === false) {
      return;
    }
    dispatch({type: CHANGE_BARCODE_VALUE, item, propName, propValue, value});
  };
};

export const ChangeBarcodeValNoHist = (item: IItem, propName: string, propValue: any) => {
  return async (dispatch: AppDispatch) => {
    dispatch({type: CHANGE_BARCODE_NO_HISTORY, item, propName, propValue});
  };
}